import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export interface GeoLocation {
  country_code: string;
  country_name: string;
}

@Injectable({
  providedIn: 'root'
})
export class GeoService {
  private geoApiUrl = 'https://ipapi.co/json/';

  constructor(private http: HttpClient) {}

  getUserCountry(): Observable<string | null> {
    return this.http.get<GeoLocation>(this.geoApiUrl).pipe(
      map(response => response.country_code),
      catchError(() => of(null))
    );
  }
}
